import { useParams, Navigate } from 'react-router-dom';

import PageLoading from '@/components/layout/PageLoading';

import { useCardLink } from '@/data/card';

const CardLinkRedirectPage = () => {
  const params = useParams();
  const cardLink = useCardLink(params.hash);

  if (cardLink.isLoading) {
    return <PageLoading />;
  }

  const url = new URL(cardLink.data.redirect);
  const path = url.pathname + url.search; // Include the query string

  return <Navigate to={path} replace />;
};

export default CardLinkRedirectPage;
